import { createContext, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "./api";

const FlagsContext = createContext(null);

export const FlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState(null);
  useEffect(() => {
    api.get("/flags").then((r) => {
      window.__xpNarrVol = Math.max(0, Math.min(1, (r.data.narration_volume ?? 100) / 100));
      setFlags(r.data);
    }).catch(() => setFlags({}));
  }, []);
  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>;
};

export const useFlags = () => useContext(FlagsContext);

export const flagOn = (flags, flag) => !flags || flags[flag] !== false;

export const ModuleGate = ({ flag, children }) => {
  const flags = useFlags();
  if (!flagOn(flags, flag)) {
    return (
      <div data-testid={`module-disabled-${flag}`} className="p-6 pt-20 text-center">
        <p className="text-[10px] tracking-[0.35em] text-[#D4AF37]">MODULE DISABLED</p>
        <p className="font-display text-3xl font-bold mt-2">This experience is switched off</p>
        <p className="text-sm text-white/50 mt-2">The <span className="font-mono text-white/70">{flag}</span> feature flag is currently disabled in this preview.</p>
        <div className="flex gap-3 justify-center mt-6">
          <Link to="/experience" className="bg-[#D4AF37] text-black text-xs font-bold rounded-full px-5 py-3 tracking-widest">BACK HOME</Link>
          {sessionStorage.getItem("xp_admin_ok") === "1" && (
            <Link to="/experience/admin" className="border border-white/20 text-white/70 text-xs font-bold rounded-full px-5 py-3 tracking-widest">ADMIN</Link>
          )}
        </div>
      </div>
    );
  }
  return children;
};
